import {API_ACCOUNT} from "@/app/_api/types/account";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest} from "@/Fwk/Http/comRequest";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import {NetType} from "@/Fwk/Http/NetType";

export async function getUserInfo(params: object = {}): Promise<API_ACCOUNT.UserInfoResponse> {
    // const config: RequestConfig = {
    //     // url: RequestMgr.getUrl(NetType.GetUserInfo),
    //     method: 'POST',
    //     body: params,
    // };
    // const response = await request<API_ACCOUNT.UserInfoResponse>(RequestMgr.getUrl(NetType.GetUserInfo), config);
    // return response ;
    const config:HttpConfig = {
        url: RequestMgr.getUrl(NetType.GetUserInitInfo),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API_ACCOUNT.UserInfoResponse>(config);
    return response.data;
}

export async function gameLevelList(params = {}): Promise<API_ACCOUNT.GameLevelListResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.GameLevels),
        method: 'POST',
        body: params,
        // headers: {
        //     'Authorization': LoginNetManager.Instance.getLoginToken
        // },
    };
    const response = await DoSendRequest<API_ACCOUNT.GameLevelListResponse>(config);
    return response.data;
}

export async function vipConfigList(params = {}): Promise<API_ACCOUNT.VipConfigListResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.VipConfigs),
        method: 'POST',
        body: params,
        // headers: {
        //     'Authorization': LoginNetManager.Instance.getLoginToken
        // },
    };
    const response = await DoSendRequest<API_ACCOUNT.VipConfigListResponse>(config);
    return response.data;
}

export async function userSignOut(params = {}): Promise<Boolean> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.Logout),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<Boolean>(config);
    return response.data;
}

export async function updateUser(params: {userId: number, nickname: string}): Promise<API_ACCOUNT.UpdateUserResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.UpdateUser),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API_ACCOUNT.UpdateUserResponse>(config);
    return response.data;
}

export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
    config.isSerErrTips = true;
    const sendRequest = await comRequest<T>(config);
    return sendRequest;
}

// export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
//     // config.isSerErrTips = true;
//
//     const config2 : RequestConfig = {
//         method: config.method,
//         body: config.body,
//     }
//
//     const sendRequest = await request(config.url, config2);
//     return sendRequest;
// }
